<template>
  <div class="i-team-multi-picker">
    <div class="field-label">
      {{ label }}
    </div>
    <multiselect
      ref="multi"
      v-model="selected"
      label="name"
      trackBy="id"
      :options="sharedFolders"
      :multiple="false"
      :placeholder="placeholder"
      @search-change="onSearch"
      @select="onSelect"
      @remove="onRemove"
      @open="onOpen"
      @keydown.native="onKeydown"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {listSharedFolders} from "@/services/api/dropbox/recovery/shared-folder/sharedFolder";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'ISharedFolderPicker',
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: 'Team folder'
    },
    placeholder: {
      type: String,
      default: 'Search for team folders here'
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    }
  },

  data() {
    return {
      selected: null,
      sharedFolders: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.sharedFolders = [];
      this.loadSharedFolders(searchTerm)
    },
    loadSharedFolders(search = null) {
      listSharedFolders({
        pagination: {
          ...defaultPagination(),
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      })
        .then(({result, pagination}) => {
          this.sharedFolders = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    },
    onOpen() {
      this.$nextTick(this.scrollHighlightedIntoView);
    },
    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView);
      }
    },
    scrollHighlightedIntoView() {
      const multi = this.$refs.multi;
      if (!multi || !multi.$el) return;

      const wrapper = multi.$el.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;

      const highlighted = wrapper.querySelector('.multiselect__option--highlight');
      if (highlighted) {
        highlighted.scrollIntoView({block: 'nearest'});
      }
    },
  },

  created() {
    if (this.value?.status != 4) {
      this.selected = this.value;
    }

    this.loadSharedFolders();
  },
}
</script>

<style lang="scss">
@import "ITeamPicker.scss";
</style>
